import { render } from "./CasesReel.vue?vue&type=template&id=7351cddd&scoped=true"
import script from "./CasesReel.vue?vue&type=script&lang=js"
export * from "./CasesReel.vue?vue&type=script&lang=js"

import "./CasesReel.vue?vue&type=style&index=0&id=7351cddd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7351cddd"]])

export default __exports__